// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__g0a0f","inputWrap":"CustomTip_inputWrap__ZILvN"};